// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uMRVM4xbuDwqtUBXEoJi{gap:8px;display:grid}.N9br7Uh4KM8e9bQFRweg{border:1px solid var(--border-neutral-default);height:40px}.N9br7Uh4KM8e9bQFRweg:not(.nm8YWtkTVggFJaN1UEli):hover{border:none}.N9br7Uh4KM8e9bQFRweg.nm8YWtkTVggFJaN1UEli{color:var(--content-brand-secondary);background:var(--light-blue-20);border:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `uMRVM4xbuDwqtUBXEoJi`,
	"chip": `N9br7Uh4KM8e9bQFRweg`,
	"active": `nm8YWtkTVggFJaN1UEli`
};
export default ___CSS_LOADER_EXPORT___;
